export default {
  title: 'Bestelmethoden',
  paywall: {
    live_title: '{{name}} is live!',
  },
  tabs: {
    general: 'Algemeen',
    pickup: 'Afhalen',
    delivery: 'Bezorging',
    table_ordering: 'Tafelbestellen',
  },
  modals: {
    update_confirmation: {
      title: 'Weet u zeker dat u de nieuwe wijzigingen wilt opslaan?',
      buttons: {
        confirm: 'Bevestigen',
        cancel: 'Annuleren',
      },
    },
    switch_live_orders: {
      titles: {
        disable: 'Weet u zeker dat u live bestellingen wilt uitschakelen?',
        enable: 'Weet u zeker dat u live bestellingen wilt inschakelen?',
      },
      buttons: {
        yes: 'Ja',
        no: 'Nee',
      },
    },
  },
  toasts: {
    failed_to_save_changes: 'Wijzigingen opslaan mislukt',
    changes_got_saved: 'Wijzigingen opgeslagen',
    table_ordering_saved: 'Tafelbestellen opgeslagen',
  },
};
